import { render, staticRenderFns } from "./the-progress-of-the-problem.vue?vue&type=template&id=f83ae2fc"
import script from "./the-progress-of-the-problem.vue?vue&type=script&lang=js"
export * from "./the-progress-of-the-problem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports